export default class NotificationService {

}
